<div class="close-button__container close-button__container--primary">
  <img
    src="../../../assets/icon/close.svg"
    alt="close"
    [id]="SettingsIntroIds['#settings__close-button']"
  />
</div>
